import { warn as _warn } from 'vue';

export function warn(component: string, msg: string) {
  if (import.meta.env.DEV) {
    _warn(`[CDS: ${component}] ${msg}`);
  }
}
